import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (

        <footer className='footer'>

            <div class="top">

                <div >
                    <h4 className=''>Address</h4>
                    <div class="social2">
                        <li>Doliya, Akhalia,</li>
                        <li>Sylhet, Bangladesh</li>
                        <li>shongkor.talukdar@outlook.com</li>
                        <li>+880 1755-077446</li>
                    </div>
                </div>
                <div className='forSmall'>
                    <h4 className=''>Connect With Me</h4>
                    <div class="social">
                        <Link to="https://github.com/Shongkor" target='blank'><i class="fab fa-github"></i></Link>
                        <Link to="https://www.linkedin.com/in/shongkor-talukdar/" target='blank'><i class="fab fa-linkedin"></i></Link>
                        <Link to="https://www.facebook.com/shongkor.takukdar/" target='blank'><i class="fab fa-facebook"></i></Link>

                    </div>
                </div>
            </div>


            <div class="info">
                <div class="legal">
                    <a href="#">Terms & Conditions</a><a href="#">Privacy Policy</a>
                </div>
                <div class="copyright">2024 Copyright &copy; Shongkor</div>
            </div>
        </footer>

    );
};

export default Footer;